// Lightweight analytics stub — replace with real implementation as needed

export const EVENTS = {
  HOMEPAGE_VIEW: 'homepage_view',
  CTA_CLICKED: 'cta_clicked',
  SECTION_VIEWED: 'section_viewed',
  AUDIENCE_TOGGLED: 'audience_toggled',
};

export function trackEvent(eventName, properties = {}) {
  if (process.env.NODE_ENV === 'development') {
    console.log('[Analytics]', eventName, properties);
  }
  // TODO: wire up to your analytics provider (e.g. Segment, Mixpanel, PostHog)
  if (typeof window !== 'undefined' && window.analytics) {
    window.analytics.track(eventName, properties);
  }
}

export function trackSectionView(sectionId) {
  trackEvent(EVENTS.SECTION_VIEWED, { section: sectionId });
}
